import 'css-chunksrc/client/scenes/calendarHolidaysEdition/styles.scss';export default {
  "calendarHolidaysEdition": "_calendarHolidaysEdition_1nu7v_1",
  "main": "_main_1nu7v_6",
  "footer": "_footer_1nu7v_15",
  "button": "_button_1nu7v_23"
};